// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"532":"e071736c2e82cefd09fa","678":"704fa164979697cd0bc0","731":"7279ead836650a659d20","843":"2d1bb769e98b039e6434","883":"6ae610d9530030dfe9c4"}[chunkId] + ".js";
};